/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import useSWR from 'swr';

import request from '@/utils/request';
import type * as Type from '@/common/interface';

export const usePublicWechatGroups = () => {
  const { data, error, mutate } = useSWR<Type.WechatGroupQRCodeItem[]>(
    '/answer/api/v1/wechat-groups/home',
    request.instance.get,
  );
  return {
    data,
    isLoading: !data && !error,
    error,
    mutate,
  };
};

export const getMyWechatGroup = () => {
  return request.get<Type.WechatGroupQRCodeItem | null>(
    '/answer/api/v1/wechat-groups/my',
    { allow404: true },
  );
};

export const saveMyWechatGroup = (params: {
  title: string;
  note?: string;
  file?: File | null;
}) => {
  const form = new FormData();
  form.append('title', params.title);
  form.append('note', params.note || '');
  if (params.file) {
    form.append('file', params.file);
  }
  return request.post<Type.WechatGroupQRCodeItem>(
    '/answer/api/v1/wechat-groups/my',
    form,
  );
};
